import PageContainer from '@/common/components/PageContainer'
import CreateDynamicSectionListing from '@/modules/client-setting/components/CreateDynamicSection/components/CreateDynamicSectionListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function CreateDynamicSectionPage() {
	return (
		<PageContainer>
			<CreateDynamicSectionListing />
		</PageContainer>
	)
}

const GuardedCreateDynamicSectionPage = withUserPermission(
	CreateDynamicSectionPage,
	{
		permissionType: PermissionType.Write,
		permissionKey: [PermissionKeys.WEB_SETTING],
	},
)

export default GuardedCreateDynamicSectionPage
